export default {"src":"/_next/static/image/public/images/icons/success-toast.c925afacd3a756cabcbddc385916eec7.svg","height":16,"width":16};